export default "__VITE_ASSET__C7ZvOQ48__"